<script>
import { mapGetters } from 'vuex'
import desctopLogoIcon from '@/assets/images/logo-desktop.svg?inline'
import TouristMenu from './ui/Tourist.vue'
import AgencyMenu from './ui/Agency.vue'
import ContactsMenu from './ui/Contacts.vue'
import UserMenu from './ui/User.vue'
import Rates from './views/Rates.vue'

export default {
  name: 'app-header',
  components: {
    desctopLogoIcon,
    TouristMenu,
    AgencyMenu,
    ContactsMenu,
    UserMenu,
    Rates
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.getters['account/getAccess']
    },
    userProfile() {
      return this.$store.getters['profile/getUserProfile']
    },
    ...mapGetters('account', [
      'checkPhonesForIndividualsAccess',
      'checkPhonesForAgentsAccess',
      'checkSaleAccess',
      'checkNestedForIndividualsAccess',
      'checkNestedForAgentsAccess',
      'checkContactsAccess'
    ])
  },
  created() {
    if (this.isUserLoggedIn) {
      this.$store.dispatch('profile/getProfile')
    }
  }
}
</script>

<template>
  <header class="app-header">
    <rates />
    <div class="app-header__content">
      <div class="app-header__main">
        <router-link
          :to="{
            name: 'Main'
          }"
          class="app-header__logo"
        >
          <desctopLogoIcon />
        </router-link>
        <p class="app-header__city">
          Москва
        </p>
        <div
          v-if="checkPhonesForIndividualsAccess"
          class="app-header__contacts"
        >
          <p class="app-header__contacts-title">
            Для туристов:
          </p>
          <div class="header__contacts-phones">
            <a
              href="tel:+7 (800) 775-66-99"
              class="app-header__contacts-phones-item"
            >+7 (800) 775-66-99</a>
          </div>
        </div>
        <div
          v-if="checkPhonesForAgentsAccess"
          class="app-header__contacts"
        >
          <p class="app-header__contacts-title">
            Для агентов:
          </p>
          <div class="header__contacts-phones">
            <a
              href="tel:+7 (495) 925-66-99"
              class="app-header__contacts-phones-item"
            >+7 (495) 925-66-99</a>
          </div>
        </div>
        <div class="app-header__menu">
          <router-link
            v-if="checkSaleAccess"
            :to="{ name: 'Sale' }"
            class="app-header__menu-singl app-header__dropdown-item"
          >
            <span>Горячие&nbsp;предложения</span>
          </router-link>
          <tourist-menu
            v-if="checkNestedForIndividualsAccess"
          />
          <agency-menu
            v-if="checkNestedForAgentsAccess"
          />
          <contacts-menu
            v-if="checkContactsAccess"
          />
          <div class="app-header__user">
            <div class="app-header__user-avatar">
              <img
                v-if="userProfile.image"
                :src="userProfile.image"
                alt=""
              >
              <img
                v-else
                src="@/assets/images/default.jpg"
                alt=""
              >
            </div>
            <user-menu />
            <router-link
              v-if="!isUserLoggedIn"
              :to="{
                name: 'Login'
              }"
              class="app-header__auth-link"
            >
              Войти
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
